import React from 'react'
import PropTypes from 'prop-types'
import { clamp } from './utils/innerSliderUtils'

const getDotCount = (spec) =>
  spec.infinite
    ? Math.ceil(spec.slideCount / spec.slidesToScroll)
    : Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1

export class Dots extends React.PureComponent {
  clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault()
    this.props.clickHandler(options)
  }

  render() {
    const {
      onMouseEnter,
      onMouseOver,
      onMouseLeave,
      infinite,
      slidesToScroll,
      slidesToShow,
      slideCount,
      currentSlide,
    } = this.props
    const dotCount = getDotCount({
      slideCount,
      slidesToScroll,
      slidesToShow,
      infinite,
    })

    const mouseEvents = { onMouseEnter, onMouseOver, onMouseLeave }
    let dots = []
    for (let i = 0; i < dotCount; i++) {
      const _rightBound = (i + 1) * slidesToScroll - 1
      const rightBound = infinite
        ? _rightBound
        : clamp(_rightBound, 0, slideCount - 1)
      const _leftBound = rightBound - (slidesToScroll - 1)
      const leftBound = infinite
        ? _leftBound
        : clamp(_leftBound, 0, slideCount - 1)

      const isActive = infinite
        ? currentSlide >= leftBound && currentSlide <= rightBound
        : currentSlide === leftBound

      const dotOptions = {
        message: 'dots',
        index: i,
        slidesToScroll,
        currentSlide,
      }

      const onClick = this.clickHandler.bind(this, dotOptions)
      dots = dots.concat(
        <li
          key={i}
          {...(isActive && {
            className: 'slick-active',
          })}
        >
          {React.cloneElement(this.props.customPaging(i, isActive), {
            onClick,
          })}
        </li>,
      )
    }

    return React.cloneElement(this.props.appendDots(dots), {
      className: this.props.dotsClass,
      ...mouseEvents,
    })
  }
}

Dots.propTypes = {
  afterChange: PropTypes.func,
  beforeChange: PropTypes.func,
  clickHandler: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  customPaging: PropTypes.func,
  dotsClass: PropTypes.string,
  appendDots: PropTypes.func,
  infinite: PropTypes.bool,
  initialSlide: PropTypes.number,
  slidesToScroll: PropTypes.number,
  slidesToShow: PropTypes.number,
  slideCount: PropTypes.number,
  swipeable: PropTypes.bool,
  swipeToSlide: PropTypes.bool,
  touchMove: PropTypes.bool,
  touchThreshold: PropTypes.number,
  useCSS: PropTypes.bool,
  variableWidth: PropTypes.bool,
  focusOnSelect: PropTypes.bool,
  currentSlide: PropTypes.number,
  onMouseEnter: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseLeave: PropTypes.func,
}
